import React from 'react';

const MenuTabs = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="flex flex-wrap justify-center gap-4 mb-12">
      {tabs.map((tab) => {
        const Icon = tab.icon;
        return (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`flex items-center gap-2 px-6 py-3 rounded-full font-semibold transition-all duration-300 ${
              activeTab === tab.id
                ? 'bg-neon-pink text-bg-dark'
                : 'bg-white/10 text-white hover:bg-white/20'
            }`}
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            <Icon className="w-5 h-5" />
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default MenuTabs;
